import { render, staticRenderFns } from "./VPopoverCloseBtn.vue?vue&type=template&id=5a6a0212&"
import script from "./VPopoverCloseBtn.vue?vue&type=script&lang=js&"
export * from "./VPopoverCloseBtn.vue?vue&type=script&lang=js&"
import style0 from "./VPopoverCloseBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/app/components/ui/v-icon/VIcon.vue').default})
